import { Moment } from 'moment'

export default (m: Moment) => m.format('DD-MMM-YY')
